<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div slot="content" class="box-section-scroll">
      <div
        v-for="(item,index) in myData.list"
        :key="index"
        class="d-inline-block"
        :style="{width: (100 / 2.5 )+'%' ,margin:pattern.showSpace?'0 5px':'0px'
        }"
      >
        <div
          class="w-100 box-item d-flex flex-column align-items-center"
          @click="onClickitem(item,index)"
        >
          <van-image lazy-load
            :src="showText('src',item)"
            mode="widthFix"
            :class="{'img-radius':pattern.showImgBorderRadius}"
          />
          <span class="name">{{showText('name',item)}}</span>
        </div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Object,
      default: () => {
        return {
          type: 'product',
          maxLangth: 10,
          list: [{
            src: '',
            name: '',
          },
          {
            src: '',
            name: '',
          }
          ]
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          showSpace: true,
          showImgBorderRadius: false,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      myData: this.data,
      //数据解析器
      formats: {
        product: {
          //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxProductList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxProductList, 'post', ids).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/pages/product/product',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/pages/category/category';
          }
        },
        video: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 1 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 1 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        audio: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 2 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 2 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        image: { //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 3 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 3 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        live: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxLiveList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxLiveList, 'post', ids).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'cover',
              format: this.defaultSrcFormat
            },
            name: {
              key: 'name',
              format: this.defaultFormat
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/live/live',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/live/list';
          }
        },
      },
    };
  },
  created () {
    this.refreshData()
  },
  methods: {
    //数据展示
    showText (key, item) {
      let text = this.formats[this.data.type].dataSwitch[key].format(item[this.formats[this.data.type].dataSwitch[key].key], item)
      return text
    },
    //默认的数据格式化
    defaultFormat (text) {
      return text
    },
    defaultSrcFormat (text) {
      let type = this.$getType(text)
      if (type == '[object Array]') {
        return text.length > 0 ? text[0] : ''
      } else if (type == '[object String]') {
        try {
          let texts = JSON.parse(text)
          return texts.length > 0 ? texts[0] : ''
        } catch{
          return text
        }
      }
      return ''
    },
    onClickMore () {
      this.$router.push(this.formats[this.data.type].moreRouter())
    },
    onClickitem (item, index) {
      this.$router.push(this.formats[this.data.type].detailRouter(item))
    },
    refreshData () {
      if (this.data.list.length == 0) {
        this.formats[this.data.type].getDataFunc()
      } else {
        if (this.type == 'default') {
          this.formats[this.data.type].refreshDataFunc()
        }
      }
    },
    warchRefreshData () {
      if (this.data.list.length == 0) {
        this.formats[this.data.type].getDataFunc()
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal, oldVal) {
        let myDataStr = JSON.stringify(oldVal)
        let newValStr = JSON.stringify(newVal)
        if (myDataStr != newValStr) {
          this.myData = JSON.parse(JSON.stringify(newVal))
          this.refreshData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-section-scroll {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}

img {
  display: block;
  width: 100%;
}

.width {
  width: 17px;
}

.name {
  margin-top: 5px;
  font-size: $uni-font-size-lg;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
</style>
